module.exports = __webpack_public_path__ + "static/img/ss01@2x.e7ba2ec2.png";